import { render, staticRenderFns } from "./expirenza_review_params.vue?vue&type=template&id=46ed65a7&scoped=true&"
import script from "./expirenza_review_params.vue?vue&type=script&lang=js&"
export * from "./expirenza_review_params.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed65a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ed65a7')) {
      api.createRecord('46ed65a7', component.options)
    } else {
      api.reload('46ed65a7', component.options)
    }
    module.hot.accept("./expirenza_review_params.vue?vue&type=template&id=46ed65a7&scoped=true&", function () {
      api.rerender('46ed65a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/review/location/providers/expirenza_review_params.vue"
export default component.exports